import React from 'react';
import { MapPin } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';

export const AddressTab = ({ profileData, saving, onChange, onSubmit }) => (
  <Card className="bg-purple-800/50 border-purple-600">
    <CardHeader>
      <CardTitle className="text-white flex items-center gap-2">
        <MapPin className="w-5 h-5 text-yellow-400" />
        Shipping Address
      </CardTitle>
    </CardHeader>
    <CardContent>
      <form onSubmit={onSubmit} className="space-y-4">
        <div className="space-y-2">
          <Label htmlFor="line1" className="text-purple-100">Street Address</Label>
          <Input
            id="line1"
            name="line1"
            value={profileData.line1}
            onChange={onChange}
            placeholder="123 Main Street"
            className="bg-purple-900/50 border-purple-600 text-white placeholder:text-purple-400"
            data-testid="address-line1-input"
          />
        </div>
        <div className="space-y-2">
          <Label htmlFor="line2" className="text-purple-100">Apt, Suite, etc. (Optional)</Label>
          <Input
            id="line2"
            name="line2"
            value={profileData.line2}
            onChange={onChange}
            placeholder="Apt 4B"
            className="bg-purple-900/50 border-purple-600 text-white placeholder:text-purple-400"
            data-testid="address-line2-input"
          />
        </div>
        <div className="grid grid-cols-2 gap-4">
          <div className="space-y-2">
            <Label htmlFor="city" className="text-purple-100">City</Label>
            <Input
              id="city"
              name="city"
              value={profileData.city}
              onChange={onChange}
              className="bg-purple-900/50 border-purple-600 text-white"
              data-testid="address-city-input"
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="state" className="text-purple-100">State</Label>
            <Input
              id="state"
              name="state"
              value={profileData.state}
              onChange={onChange}
              placeholder="GA"
              className="bg-purple-900/50 border-purple-600 text-white placeholder:text-purple-400"
              data-testid="address-state-input"
            />
          </div>
        </div>
        <div className="grid grid-cols-2 gap-4">
          <div className="space-y-2">
            <Label htmlFor="postal_code" className="text-purple-100">ZIP Code</Label>
            <Input
              id="postal_code"
              name="postal_code"
              value={profileData.postal_code}
              onChange={onChange}
              className="bg-purple-900/50 border-purple-600 text-white"
              data-testid="address-zip-input"
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="country" className="text-purple-100">Country</Label>
            <Input
              id="country"
              name="country"
              value={profileData.country}
              onChange={onChange}
              className="bg-purple-900/50 border-purple-600 text-white"
              data-testid="address-country-input"
            />
          </div>
        </div>
        <Button
          type="submit"
          disabled={saving}
          className="bg-yellow-500 hover:bg-yellow-600 text-purple-900"
          data-testid="save-address-btn"
        >
          {saving ? 'Saving...' : 'Save Address'}
        </Button>
      </form>
    </CardContent>
  </Card>
);
